export default __webpack_public_path__ + "static/creator-illustration-dark-91935dcd4960e38f3693b914c5f66c7c.svg";